
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartDatedObjectsIec as ObiChartDatedObjectsIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-dated-objects-iec.js';
 
 
 

 
 export const ObiChartDatedObjectsIec = createComponent({
   react: React,
   tagName: 'obi-chart-dated-objects-iec',
   elementClass: ObiChartDatedObjectsIecElement,
   events: {
     
   }
  });
 
 